import { useMutation, useQueryClient } from '@tanstack/react-query';

import { apiClient } from '@services/apiClient';

import type { TSourceData } from '../model/translateSourceDataList';
import { translateSourceDataListKey } from './useTranslateSourceDataListQuery';

const saveTranslationFn = (data: {
  id: number[];
  type: string;
  field: string;
  translation: {
    [x: number]: string;
  };
}) => apiClient.post(`${APP_API_URL}equipments/translate`, data);

export const useSaveTranslationMutation = (type: TSourceData) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: saveTranslationFn,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [translateSourceDataListKey()[0], type] });
    },
  });
};
